import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import Isotope from 'isotope-layout';
var Flickity = require('flickity');
require('@fancyapps/fancybox');

const LazyLoad = require('lazyload');


$('[data-fancybox]').fancybox({
  video : {
    autoplay : true
  }
});

var sliderGrid = document.querySelector('.js-cliderGrid');
if (sliderGrid) {

  var carousel = new Flickity('.js-cliderGrid', {
    pageDots: true,
    imagesLoaded: false,
    pauseAutoPlayOnHover: false,
    groupCells: 1,
    cellAlign: "left",
    contain: true,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: false,
    autoPlay: false, 
  });

  carousel.on('select', function() {
    var currentIndex = carousel.selectedIndex;
    var videos = document.querySelectorAll('.c-slider__item video');

    videos.forEach(function(video, index) {
      if (index === currentIndex) {
        video.play();
        carousel.stopPlayer();
      } else {
        video.pause();
        carousel.options.autoPlay = 7000; 
        carousel.playPlayer(); 
      }
    });
  });

  var myVideoHome = document.getElementById('myVideoHome');
  if (myVideoHome) {
    myVideoHome.addEventListener('ended', function() {
      console.log('end video');
      carousel.next();
    });
  }
}


// Scripts
require('./modules/scripts');

if (document.getElementById('js-search-info-menu')){
  var buttons = document.querySelectorAll('button[type="button"]');
  var triangle = document.querySelector('#js-traingle');
  var searchInfoMenu = document.querySelector('#js-search-info-menu');
  var navLinks = document.querySelectorAll('#js-search-info-menu a');
  var allBtn = document.querySelector('.c-search__btn--all'); 
  var btnJsTots = document.getElementById('btn-js-tots');
  var btnJsTot1 = document.getElementById('btn-js-tot1');
  var btnJsTot2 = document.getElementById('btn-js-tot2');
  var nav1Links = btnJsTot1.parentNode.querySelectorAll('.item-btn');
  var nav2Links = btnJsTot2.parentNode.querySelectorAll('.item-btn');
  var lastClickedButton = null;
  var iso;

  function initIsotope() {
    var grid = document.querySelector('.c-posts__grid-posts');
      iso = new Isotope(grid, {
        itemSelector: '.c-posts__article',
        layoutMode: 'masonry',
        masonry: {
          columnWidth: '.c-posts__article',
          gutter: 20
        }
      });
  }
    initIsotope();

     // Añade un event listener para el evento 'load' a todas las imágenes
    let images = document.querySelectorAll(".item-poster");
    new LazyLoad(images);
    images.forEach(img => {
        img.addEventListener('load', function() {
            if(iso) iso.layout();
        });
    });



  buttons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      event.stopPropagation();  

      var positionInContainer = {
        left: button.offsetLeft
      };

      var newLeft = positionInContainer.left + (button.offsetWidth / 2 - (7));
      triangle.style.left = newLeft + 'px';
      if (lastClickedButton == button) {
        searchInfoMenu.classList.toggle('dn');
      } else {
        searchInfoMenu.classList.remove('dn');
      }
      lastClickedButton = button;
    });
  });

  var activeFilters = [];


  // Mantener listas separadas para los filtros activos
  var activeFiltersSection = [];
  var activeFiltersLocation = [];

  navLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      var filterValue = event.target.getAttribute('data-filter');
      var filterType = event.target.closest('nav').querySelector('h4').textContent;

      if (filterType.includes("Què us interessa?")) {
        toggleFilter(filterValue, activeFiltersSection);
      } else {
        toggleFilter(filterValue, activeFiltersLocation);
      }

      applyCombinedFilters();
      link.classList.toggle('is-active');
      checkAllSelected();
    });
});

function toggleFilter(filterValue, filterArray) {
    var index = filterArray.indexOf(filterValue);
    if (index > -1) {
      filterArray.splice(index, 1);
    } else {
      filterArray.push(filterValue);
    }
}


// function applyCombinedFilters() {
//     var combinedFilterSection = activeFiltersSection.length ? activeFiltersSection : ['*'];
//     var combinedFilterLocation = activeFiltersLocation.length ? activeFiltersLocation : ['*'];

//     var finalFilters = [];

//     combinedFilterSection.forEach(section => {
//         combinedFilterLocation.forEach(location => {
//             if (section === '*' && location !== '*') {
//                 finalFilters.push(location);
//             } else if (section !== '*' && location === '*') {
//                 finalFilters.push(section);
//             } else if (section !== '*' && location !== '*') {
//                 finalFilters.push(section + location);
//             }
//         });
//     });

//     // Unimos todos los filtros en una cadena separada por comas
//     var finalFilter = finalFilters.join(',');
//     iso.arrange({ filter: finalFilter });
//   }


function applyCombinedFilters() {
    var combinedFilterSection = activeFiltersSection.length ? activeFiltersSection : ['*'];
    var combinedFilterLocation = activeFiltersLocation.length ? activeFiltersLocation : ['*'];

    var finalFilters = [];

    combinedFilterSection.forEach(section => {
        combinedFilterLocation.forEach(location => {
            if (section === '*' && location !== '*') {
                finalFilters.push(location);
            } else if (section !== '*' && location === '*') {
                finalFilters.push(section);
            } else if (section !== '*' && location !== '*') {
                finalFilters.push(section + location);
            }
        });
    });

    // Unimos todos los filtros en una cadena separada por comas
    var finalFilter = finalFilters.join(',');
    
    // Asegurarnos de que no termine con una coma
    if (finalFilter.endsWith(',')) {
      finalFilter = finalFilter.slice(0, -1); 
    }

    iso.arrange({ filter: finalFilter });
  }


  function applyFilters() {
    var combinedFilter = activeFilters.join(',');
    if (combinedFilter.endsWith(',')) {
      combinedFilter = combinedFilter.slice(0, -1); 
    }
    console.log(combinedFilter);
    iso.arrange({ filter: combinedFilter });
  }


  allBtn.addEventListener('click', function(event) {
    navLinks.forEach(function(link) {
      link.classList.add('is-active');
    });
    checkAllSelected();
  });

  document.addEventListener('click', function() {
    searchInfoMenu.classList.add('dn');
  });




  function deactivateButton(link) {
  // 1. Remover la clase 'is-active'.
  link.classList.remove('is-active');

  // 2. Actualizar la lista de filtros.
  var filterValue = link.getAttribute('data-filter');
  var filterType = link.closest('nav').querySelector('h4').textContent;
  
  if (filterType.includes("Què us interessa?")) {
    const index = activeFiltersSection.indexOf(filterValue);
    if(index > -1) activeFiltersSection.splice(index, 1);
  } else {
    const index = activeFiltersLocation.indexOf(filterValue);
    if(index > -1) activeFiltersLocation.splice(index, 1);
  }
}

  btnJsTot1.addEventListener('click', function(event) {
  for(let i = 0; i < nav1Links.length; i++) {
    if (nav1Links[i].classList.contains('is-active')) {
      deactivateButton(nav1Links[i]);
    }
  }
  // 3. Aplicar los filtros combinados.
    applyCombinedFilters();
  });

  btnJsTot2.addEventListener('click', function(event) {
    for(let i = 0; i < nav2Links.length; i++) {
      if (nav2Links[i].classList.contains('is-active')) {
        deactivateButton(nav2Links[i]);
      }
    }
    // 3. Aplicar los filtros combinados.
    applyCombinedFilters();
  });

  function checkAllSelected() {
    var allSelected = true;
    navLinks.forEach(function(link) {
      if (!link.classList.contains('is-active')) {
        allSelected = false;
      }
    });

    if (allSelected) {
      btnJsTots.classList.add('is-active');
    } else {
      btnJsTots.classList.remove('is-active');
    }
  }
};











